import bearer from "@websanova/vue-auth/drivers/auth/bearer";
import axios from "@websanova/vue-auth/drivers/http/axios.1.x";
import router from "@websanova/vue-auth/drivers/router/vue-router.2.x";
import rawAxios from 'axios';

rawAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("smwtkn");

    if (token && !isTokenExpired(token)) {
      config.headers.Authorization = `Bearer ${token}`;
    } else if (token && isTokenExpired(token)) {
      // Token exists but expired, remove it
      localStorage.removeItem("smwtkn");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      console.warn("Expired token detected and removed.");
    }

    return config;
  },
  (error) => Promise.reject(error)
);

rawAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // On 401, remove token and redirect
      localStorage.removeItem("smwtkn");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      router.push('/').catch(() => {
        window.location.href = '/'; 
      });
    }
    return Promise.reject(error);
  }
);

// JWT utility functions
function parseJwtPayload(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error("Token decode failed:", e);
    return null;
  }
}

function isTokenExpired(token) {
  if (!token || typeof token !== 'string' || token.split('.').length !== 3) {
    return true;
  }

  const payload = parseJwtPayload(token);
  if (!payload || !payload.exp) {
    return true;
  }

  return Date.now() > payload.exp * 1000;
}

// Vue Auth Config
const config = {
  auth: bearer,
  http: axios,
  router: router,
  tokenDefaultKey: "smwtkn",
  tokenStore: ["localStorage"],
  rolesKey: "role",
  registerData: { url: "/api/Employee/EmployeeSignUp", method: "POST", redirect: "" },
  loginData: {
    url: "/api/Auth/Authenticate",
    method: "POST",
    redirect: "",
    fetchUser: true,
  },
  logoutData: {
    url: "",
    method: "GET",
    redirect: "/",
    makeRequest: false,
  },
  fetchData: {
    url: "/api/User/Get",
    method: "GET",
    enabled: true,
    error: (err) => {
      console.error("Fetching user data failed:", err);
      if (err.response && err.response.status === 401) {
        localStorage.removeItem("smwtkn");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");
        router.push('/').catch(() => {
          window.location.href = '/';
        });
      }
    },
  },
  refreshData: {
    enabled: false, // ✅ no refresh token logic
  },
};

export default config;
export { isTokenExpired };
